import { getApiBaseUrl } from '@/utils/apiBase';
import { storage } from '@/utils/storage';
import { getTenantSlug } from '@/utils/tenant';

export type RefreshedTokens = { accessToken: string; refreshToken: string };

/**
 * Refresh access token using the stored refresh token.
 * Shared by RTK Query, Axios interceptors, and proactive session refresh.
 */
export async function refreshAccessToken(): Promise<RefreshedTokens | null> {
  const refreshToken = storage.getRefreshToken();
  if (!refreshToken) return null;

  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  const tenantSlug = getTenantSlug();
  if (tenantSlug) headers['X-Tenant-Slug'] = tenantSlug;

  const res = await fetch(`${getApiBaseUrl()}/auth/refresh`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ refreshToken }),
    credentials: 'include',
  });

  if (!res.ok) return null;

  let json: any;
  try {
    json = await res.json();
  } catch {
    return null;
  }

  const tokens = json?.data as RefreshedTokens | undefined;
  if (!tokens?.accessToken) return null;

  storage.setAccessToken(tokens.accessToken);
  if (tokens.refreshToken) {
    storage.setRefreshToken(tokens.refreshToken);
  }

  return {
    accessToken: tokens.accessToken,
    refreshToken: tokens.refreshToken || refreshToken,
  };
}
